export default __webpack_public_path__ + "static/media/litho-demo-events-conference.b348cc84.jpg";